<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #ROLEAUTH="{ visible, params }">
      <Auth :row="params" v-if="visible" ref="childTree" />
    </template>
  </cTable>
</template>

<script>
import {
  getRole,
  add,
  getDetails,
  update,
  del,
  // getRoleAuth,
  saveRoleAuth,
  getRoleUser,
  dataRule
} from "@/api/system/role";
import { getRoleMapping } from "@/api/user/role_map";
import cTable from "@/base/common/index";
import Auth from "./auth";

export default {
  name: "role",
  components: {
    cTable,
    Auth
  },
  methods: {
    handClick(val) {
      this.autdIdList = val;
    }
  },
  data() {
    return {
      value: [],
      methods: {
        list: getRole,
        add,
        getDetails,
        update,
        del,
        // getRoleAuth,
        saveRoleAuth,
        afterHandleList() {
          this.getTable().setAllTreeExpand(true);
        },
        getRoleMapping,
        getRoleUser,
        dataRule
      },
      config: {
        height: 630,
        treeConfig: {
          children: "children",
          expandAll: true
        }
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                },
                {
                  min: 3,
                  max: 155,
                  message: "Please enter 3 to 155 characters",
                  trigger: "blur"
                }
              ],
              mapping: [
                {
                  required: true,
                  message: "parent cannot be empty",
                  trigger: "change"
                }
              ],
              sort: [
                {
                  required: true,
                  type: "number",
                  message: "type cannot be empty",
                  trigger: "change"
                }
              ],
              data_rule: [
                {
                  required: true,
                  type: "array",
                  message: "dataRule cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { title: 24 },
            { mapping: 24 },
            { sort: 24 },
            { data_rule: 24 }
          ],
          fields: [
            {
              name: this.$tz("数据,隔离,规则"),
              key: "data_rule",
              component: "Checkbox",
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: [],
              bind: {
                border: true
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("dataRule")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$tz("角色,名称"),
              key: "title",
              component: "Input",
              placeholder: () => this.$tz("角色,名称")
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 1,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: () => this.$t("type"),
              key: "mapping",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("type"),
              options: [],
              config: {
                label: "name",
                value: "code"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getRoleMapping")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            }
          ]
        },
        roleAuth: {
          methods: {
            ok: ({ row, close }) => {
              let data = {
                role_id: row.id,
                rules: this.$refs["childTree"].handClick().map(item => item.id)
              };
              this.$refs["table"]
                .handleRequestMethods("saveRoleAuth", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$refs["table"].getList();
                  close();
                });
            }
          },
          contentSlot: "ROLEAUTH",
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            title: this.$t("roleAuth")
          },
          footer: {
            show: () => true
          }
        },
        show: {
          config: {
            modalBind: {
              width: 800
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 600
            },
            fields: [
              {
                name: () => this.$t("accountNum"),
                key: "account",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("realname"),
                key: "realname",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("assistDepartment"),
                key: "title",
                align: "center",
                minWidth: 100
              }
            ]
          }
        }
      },
      footer: { show: () => false },
      header: {
        config: {
          custom: false
        },
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("roleName"),
          key: "title",
          align: "left",
          minWidth: 200,
          columnBind: {
            "tree-node": true
          }
        },
        {
          name: () => this.$t("role_t") + this.$t("noofpieces"),
          key: "role_num",
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          minWidth: 100,
          methods: {
            click({ row }) {
              this.$page.getModal("show").open(null, function() {
                this.setTitle(
                  row.title + this.$t("personnel") + this.$t("list")
                );
                this.$page
                  .handleRequestMethods("getRoleUser", row.id, false, true)
                  .then(res => {
                    this.list = res.payload.rows;
                  });
              });
            }
          }
        },
        {
          name: () => this.$t("type"),
          key: "mapping_name",
          minWidth: 160
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          width: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170
        },
        // {
        //   name: this.$t("operation"),
        //   slot: "addOperation",
        //   align: "center",
        //   width: 300
        // },
        // {
        //   name: this.$t("contraband_code"),
        //   key: "contraband_code",
        //   align: "center"
        // },
        // {
        //   name: this.$t("contraband_description"),
        //   key: "contraband_description",
        //   align: "center"
        // },
        {
          type: "btns",
          width: 300,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: this.$t("Level_child"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
                icon: "md-add"
              }
            },
            {
              name: () => this.$t("roleAuth"),
              type: "roleAuth",
              fnName: "roleAuth",
              bind: {
                type: "warning"
              },
              disabled({ row }) {
                return row.is_sup == 1;
              }
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              disabled({ row }) {
                return row.is_sup == 1;
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.is_sup == 1;
              }
            }
          ],
          methods: {
            add({ row }) {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").type = "add";
              this.getModal("add").open({ parent_id: row.id });
            },
            roleAuth({ row }) {
              this.getModal("roleAuth").open(row);
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").modal.type = "add";
                res.payload.data_rule = res.payload.data_rule
                  .split(",")
                  .map(t => ~~t);
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
